
export const AuthWrapper = ({ children }) => {
  return (
    <div className="container h-100 d-flex align-items-center justify-content-center">
      <div className="w-100">
        <div className="card min-vh-75 w-100">
          <div className="card-body p-0">
            <div className="row m-0">
              <div className="col-xl-6 col-md-6 d-none d-md-block text-center p-0">
                <img
                  src="/images/nkenne-auth.png"
                  className="img-fix"
                  alt="Visual"
                />
              </div>
              <div className="col-lg-6 col-md-6 col-12 mt-4">
                <div className="sign-in-your px-2 py-3 mt-4">{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
